<h5 class="titulo">Endereço de atendimento</h5>
<form class="form" [formGroup]="form" (submit)="prosseguir();">
  <label *ngIf="endereco" class="form__label__endereco">
    <input class="u-margin-top-0_18rem" formControlName="usarEnderecoEquipamento" type="checkbox">
    <p class="form__endereco">Manter endereço cadastrado:
      <span class="u-font-weight-600">{{endereco?.logradouro}}{{' ,' + endereco?.numero}}{{' ,' +
        endereco?.complemento}}{{'
        ,'+
        endereco?.bairro}}{{endereco?.cep ?? '' | mask: ', 00000-000'}}{{' ,'+ endereco?.cidade}}{{' - ' +
        endereco?.estado}}
      </span>
    </p>
  </label>
  <label class="form__label" for="cep">
    Cep *
    <input class="form__input" type="text" formControlName="cep" name="cep" required mask="00000-000">
  </label>
  <label class="form__label" for="logradouro">
    Logradouro (rua, av, etc) *
    <input class="form__input" type="text" formControlName="logradouro" name="logradouro" required>
  </label>
  <label class="form__label" for="numero">
    Número *
    <input class="form__input" type="text" formControlName="numero" name="numero/andar/apartamento" required>
  </label>
  <div class="form__input-duplo">
    <label class="form__label u-width-47_5-percent" for="estado">
      Estado
      <select class="form__input" formControlName="estado" name="estado" required>
        <option ngValue="">Selecione</option>
        <option *ngFor="let estado of estados" [ngValue]="estado.sigla">
          {{estado.nome}}</option>
      </select>
    </label>
    <label class="form__label u-width-47_5-percent" for="cidade">
      Cidade
      <select class="form__input" formControlName="cidade" name="cidade" required>
        <option ngValue="">Selecione</option>
        <option *ngFor="let cidade of cidades" [ngValue]="cidade.nome">
          {{cidade.nome}}</option>
      </select>
    </label>
  </div>
  <label class="form__label" for="complemento">
    Complemento
    <input class="form__input" type="text" name="complemento" formControlName="complemento">
  </label>
  <app-botao-submit [disabled]="form.invalid">Continuar</app-botao-submit>
</form>
<app-indicador-circular-paginacao class="progresso" [quantidadeDePaginas]="3"
  [paginaAtiva]="2"></app-indicador-circular-paginacao>